import type { ITheme } from '@fluentui/react';

export const getStyles = () => ({
  error: { color: '#a80000', marginTop: '8px' },
});

export const getTileHeaderStyles = () => ({
  tileHeader: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    width: '530px',
  },
  headerTitle: {
    textAlign: 'center',
    marginTop: '4px',
    marginBottom: '8px',
  },
  // size s classes
  'tileHeader-s': { width: '283px' },
  'headerTitle-s': { fontSize: '18px' },

  // size m classes
  'tileHeader-m': { width: '382px' },

  // size l classes
  'tileHeader-l': { width: '552px' },
});

export const getTileStyles = (_: unknown, { palette = {} as ITheme['palette'] }: { palette?: ITheme['palette'] }) => ({
  tile: {
    width: '700px',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '30px 0',
    background: palette.white,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    borderRadius: '2px',
  },

  navigationButtons: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
  },

  // size s classes
  'tile-s': { width: '321px' },

  // size m classes
  'tile-m': { width: '424px' },

  // size l classes
  'tile-l': { width: '618px' },
});

export const tileStyles = {
  image: { root: { marginBottom: '8px', height: 45 } },
  back: { root: { marginRight: '28px', color: '#1375DC' } },
};
